// @ts-nocheck
/**
 * Webhook picker for IVR nodes — choose a webhook / SMS webhook to fire on
 * this node's event. Drawer body uses native form-control markup so the
 * existing IVR side-drawer styling continues to apply.
 */
import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import IvrDrawer from './IvrDrawer';

const WebhookSelectModal = ({
  show,
  onClose,
  value,
  onSave,
  webhookList = [],
  smsWebhookList = [],
  title = 'Webhook Configuration',
}: any) => {
  const [draftType, setDraftType] = useState('');
  const [draftId, setDraftId] = useState('');

  useEffect(() => {
    if (show) {
      setDraftType(value?.type || '');
      setDraftId(value?.id ? String(value.id) : '');
    }
  }, [show, value]);

  const handleTypeChange = (e: any) => {
    setDraftType(e.target.value);
    setDraftId('');
  };

  const handleSave = () => {
    if (!draftType || !draftId) {
      onSave(null);
      onClose();
      return;
    }
    onSave({ type: draftType, id: draftId });
    onClose();
  };

  const handleClear = () => {
    setDraftType('');
    setDraftId('');
    onSave(null);
    onClose();
  };

  const activeList =
    draftType === 'webhook'
      ? webhookList
      : draftType === 'sms_webhook'
        ? smsWebhookList
        : [];

  return (
    <IvrDrawer
      show={show}
      onHide={onClose}
      title={title}
      subtitle="Attach a webhook to trigger on this node's event."
      footer={
        <>
          <Button
            variant="outline"
            className="text-destructive hover:text-destructive"
            onClick={handleClear}
          >
            Clear
          </Button>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
          <Button onClick={handleSave}>Save</Button>
        </>
      }
    >
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="mb-3">
          <label className="form-label">Webhook Type</label>
          <select
            className="form-control form-select"
            value={draftType}
            onChange={handleTypeChange}
          >
            <option value="">None</option>
            <option value="webhook">Webhook</option>
            <option value="sms_webhook">SMS Webhook</option>
          </select>
        </div>

        {draftType && (
          <div className="mb-3">
            <label className="form-label">
              Select {draftType === 'webhook' ? 'Webhook' : 'SMS Webhook'}
            </label>
            <select
              className="form-control form-select"
              value={draftId}
              onChange={(e) => setDraftId(e.target.value)}
            >
              <option value="">Select...</option>
              {activeList.map((w: any) => (
                <option key={w.id} value={w.id}>
                  {w.webhook_name || w.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </form>
    </IvrDrawer>
  );
};

export default WebhookSelectModal;
